import {
    AfterContentInit,
    Directive,
    ElementRef,
    Inject,
    Input,
} from '@angular/core';

@Directive({ selector: '[nddFocus]' })
export class NDDFormsFocusDirective implements AfterContentInit {
    @Input() public nddFocus: boolean;

    private elm: HTMLElement;

    constructor(@Inject(Window) private window: Window, elmRef: ElementRef) {
        this.elm = elmRef.nativeElement;
    }

    public ngAfterContentInit(): void {
        this.focus();
    }

    private focus(): void {
        if (this.nddFocus) {
            this.window.setTimeout(() => {
                this.elm.focus();
                // tslint:disable-next-line:no-magic-numbers
            }, 100);
        }
    }
}
